import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    listAuditTrails(page, pageSize, search) {
        return axios.get(`auditLogs?page=${page}&pageSize=${pageSize}&search=${search}`)
    },

}